module.exports = __webpack_public_path__ + "img/Yemen, Rep..fc5efeca.gif";